import { render, staticRenderFns } from "./Integracao.vue?vue&type=template&id=3130c8bf&scoped=true"
import script from "./Integracao.vue?vue&type=script&lang=js"
export * from "./Integracao.vue?vue&type=script&lang=js"
import style0 from "./Integracao.vue?vue&type=style&index=0&id=3130c8bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3130c8bf",
  null
  
)

export default component.exports